import { DO_LOGOUT } from '../Login/actions'
import { DISABLE, ENABLE } from './actions'

const initialState = {
    disableWhereAndWhenBlock: false,
}

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {

        case DISABLE:
            return {
                ...state,
                disableWhereAndWhenBlock: true
            }
        case ENABLE:
            return {
                ...state,
                disableWhereAndWhenBlock: false
            }
            case DO_LOGOUT:
                return initialState;
    }
    return state
}

export default reducer